
import { Component, Prop, Vue } from 'vue-property-decorator';
import { ClientType } from 'ah-api-gateways';
import { findComponentBasePath } from 'ah-common-lib/src/helpers/route';
import config from '@/config';
import { useAuthStore } from '@/app/store/authModule';
import { useIndividualSettingsStore } from '@/app/store/individualSettingsModule';

@Component
export default class SettingsSidebarView extends Vue {
  @Prop({ default: '' }) path!: string;

  private basePath = '';

  created() {
    this.individualSettingsStore.loadClient();
  }

  get authStore() {
    return useAuthStore();
  }

  get individualSettingsStore() {
    return useIndividualSettingsStore();
  }

  get isCompanyClient() {
    return this.individualSettingsStore.client?.type === ClientType.COMPANY;
  }

  get isAdmin() {
    return this.authStore.isAdminUser;
  }

  get showDevTools() {
    return config.showDevTools;
  }

  mounted() {
    this.basePath = this.path;
    if (this.path === '') {
      this.basePath = findComponentBasePath(this);
    }
  }
}
